module.exports = __webpack_public_path__ + "static/media/close.f7d70fe4.svg";